import React from 'react';
import { IIconProps } from './IIconProps';

export const AddIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 32 32"
			className={`icon ${iconClass}`}
		>
			{title && <title>{title}</title>}
			<path d="M13.714 0v13.714h-13.714v4.571h13.714v13.714h4.571v-13.714h13.714v-4.571h-13.714v-13.714h-4.571z" />
		</svg>
	);
};
